// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from './selecao_todos_nfe';
import CamposDocumento from '../../common/campos_documento';
import { Input } from '../../../../../../common/input';

export default function CamposBasicos() {
  return (
      <FormSection name="dadosBasicos">
        <SelecaoTodosNfe nomes={ ["dadosBasicos"] } titulo="Dados Básicos"/>
        <div className="grupo-checkbox">
          <CamposDocumento/>

          <Input name="naturezaOperacao" label="Natureza da Operação" checkbox/>
          <Input name="munFatoGeradorIcms" label="Município Gerador ICMS" checkbox/>
          <Input name="munFatoGeradorIbsCbs" label="Município Gerador IBS/CBS" checkbox/>
          <Input name="tipoOperacaoIdEDescr" label="Operação (entrada ou saída)" checkbox/>
          <Input name="destinoOperacao" label="Destino da Operação" checkbox/>
          <Input name="tipoEmissao" label="Tipo de Emissão" checkbox/>
          <Input name="finalidade" label="Finalidade de Emissão" checkbox/>
          <Input name="tipoNotaDebito" label="Tipo de Nota de Débito" checkbox/>
          <Input name="tipoNotaCredito" label="Tipo de Nota de Crédito" checkbox/>
          <Input name="consumidorFinal" label="Consumidor Final" checkbox/>
          <Input name="indicadorPresenca" label="Presença do comprador" checkbox/>
          <Input name="indicadorIntermediador" label="Indicador de Intermediador" checkbox/>
          <Input name="cnpjIntermediador" label="CNPJ Intermediador" checkbox/>
          <Input name="idIntermediador" label="Identificação do Intermediador" checkbox/>
          <Input name="processoEmissao" label="Processo de Emissão" checkbox/>
          <Input name="versaoProcesso" label="Versão do Processo" checkbox/>
          <Input name="digestValue" label="Digest Value" checkbox/>
          <Input name="entradaSaida" label="Data de Entrada / Saída" checkbox/>
          <Input name="situacaoSefaz" label="Situação na SEFAZ" checkbox/>

          <Input name="autorizadoEm" label="Data de Autorização" checkbox/>
          <Input name="numeroProtocolo" label="Protocolo de Autorização" checkbox/>
          <Input name="informacoesAdicionaisFisco" label="Inform. Adicionais Fisco" checkbox/>
          <Input name="informacoesComplementares" label="Inform. Complementares" checkbox/>
        </div>
      </FormSection>
  );
}